import { QUICK_INFO_BUTTONS } from '@aibees/elephant/components/quick-info-group/components/quick-info-button';
import {
  ProcessingItemState,
  useActionButtonContext,
} from '@aibees/elephant/context/action-button-context';
import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { usePersonUpdatesStore } from '@aibees/elephant/store/person-updates';
import { SearchType } from '@aibees/elephant/types';
import { notificationIconMap } from '@aibees/elephant/utils';
import { useAuthContext } from '@aibees/shared/auth';
import { useNotify } from '@aibees/shared/hooks';
import { useWorkspaceUsers } from '@aibees/shared/workspace';
import { MouseEventHandler } from 'react';
import { SaveRecordAction, SaveRecordRequest } from '../types';
import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { useSaveRecord } from '../use-save-record';
import { useTrackEvents } from '../use-track-events';
import { useCheckRevelationPeoplePhoneState } from './use-check-revelation-people-phone-state';
import { usePeoplePhoneNumberLoading } from './use-people-phone-number-loading';

export function useUnlockPeoplePhoneNumber(item?: PeopleTableInfo) {
  const users = useWorkspaceUsers(true);
  const { user } = useAuthContext();
  const selectedUser = users.find((u) => u.id === user?.id);
  const searchType = useSearchTypeFromRoute();
  const { track } = useTrackEvents();
  const { mutateAsync } = useSaveRecord(SearchType.People);
  const notify = useNotify();
  // const { loadingPhoneNumber } = useIsPeopleUnlockButtonLoading(item);
  const { loading: loadingPhoneNumber } = usePeoplePhoneNumberLoading(item);

  const unlocked = useCheckRevelationPeoplePhoneState(item);
  const { setEmailsUpdateTriggered } = usePersonUpdatesStore();

  const { addProcessingItems, removeProcessingItems } =
    useActionButtonContext();
  // TODO add this hook
  // const hasUpdate = doesPhoneEnrichmentHaveAnyUpdates(item);
  const handleUnlock: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (loadingPhoneNumber) return;

    if (item?.id) {
      const payload: SaveRecordRequest = {
        kind: 'ADD',
        actions: [SaveRecordAction.CONTACT_REVEAL_PHONE_CACHED],
        ids: [item?.id],
        overwriteOwner: false,
        user: selectedUser,
        labels: [],
      };
      addProcessingItems({
        id: item.id,
        type: QUICK_INFO_BUTTONS.PHONENUMBER_ENRICHMENT,
        state: ProcessingItemState.UNLOCKING,
      });
      const key = Date.now().toString();

      mutateAsync(payload)
        .then(() => {
          notify.progress(
            'Your request is in progress',
            'Processing the contact details. Please wait...',
            key,
            {
              icon: notificationIconMap.ContactDetails,
            }
          );
          track('UNLOCK_PHONE', {
            multiple: false,
            sidebar: false,
            searchType,
          });
        })
        .catch(() => {
          removeProcessingItems({
            id: item.id,
            type: QUICK_INFO_BUTTONS.PHONENUMBER_ENRICHMENT,
          });
        });
    }
  };

  return {
    handleUnlock,
    loading: loadingPhoneNumber,
    unlocked,
  };
}
